import * as api from "Api";
import * as actions from "Actions";
import { MODEL_PARENTS } from "../../config";

export const fetchBalanceSheet = (uen, filterTypePeriod, year = null) => {
  return (dispatch, getState) => {
    let orgUen = uen,
      typePeriod = filterTypePeriod;

    if (typePeriod == null) {
      typePeriod = "Annuel";
    }
    if (!orgUen) {
      const { organization } = getState().balanceSheet;
      if (organization) {
        orgUen = organization.uen;
      }
    }
    const { lng } = getState().params;

    const { model } = getState().balanceSheet;
    const parents = MODEL_PARENTS[model];

    dispatch(
      actions.fetchBalanceSheet(
        api
          .getBalanceSheet({
            uen: orgUen,
            model: model,
            parents: parents,
            language: lng,
            filterTypePeriod: typePeriod,
            year: year
          })
          .then(res => {
            return res.data.data;
          })
      )
    );
  };
};



// WEBPACK FOOTER //
// ./src/actions/thunks/balance-sheet.js